import { Component, OnInit } from '@angular/core';
//import * as $ from 'jquery';
declare const $: any;

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {
 

  ngOnInit(): void {
  }
}
